import { render, staticRenderFns } from "./CaseViewerHeader.vue?vue&type=template&id=19d066c1&scoped=true&"
import script from "./CaseViewerHeader.vue?vue&type=script&lang=js&"
export * from "./CaseViewerHeader.vue?vue&type=script&lang=js&"
import style0 from "./CaseViewerHeader.vue?vue&type=style&index=0&id=19d066c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d066c1",
  null
  
)

export default component.exports